export const GET_APP_INFO = "GET_APP_INFO";
export const GET_APP_INFO_SUCCESS = "GET_APP_INFO_SUCCESS";
export const GET_APP_INFO_FAILURE = "GET_APP_INFO_FAILURE";
